import styled from 'styled-components';
import TxtField02 from 'dc/TxtField02';
import Btn021 from 'dc/Btn021';
import { Typ30 } from 'dc/Typ';

export const TextFieldWrapper = styled.div`
  width: 100%;
  margin: 19px 0 22px;
`;

export const TextField = styled(TxtField02)`
  input {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const Button = styled(Btn021)`
  width: 100%;
`;

export const ErrorText = styled(Typ30)`
  display: block;
  line-height: 20px;
  color: #e0487b;
  width: 288px;
  text-align: center;
  padding: 8px 0;
`;
